const funcion = {
  ObtenUsuario: 'Cuentas/Funciones/ObtenUsuario',
  CambiarContrasena: 'Cuentas/Funciones/CambiarContrasena'
}

export default funcion



//////////////////
// WEBPACK FOOTER
// ./static/js/api/Cuentas/funcion/funcion.js
// module id = null
// module chunks = 